import { BrowserRouter, Navigate, Routes, Route } from 'react-router-dom';
import { InvitationLayout, Layout, LoginLayout } from 'layout';
import {
  EtzProfileTransactions,
  EtzProfileAssets,
  EtzProfileRevenueTable,
  EtzProfileInflowOutflowTable,
  Employers,
  IraUsers,
  IraUserNew,
  IraUserInfo,
  Login,
  LoginBlocked,
  ForgotPassword,
  ForgotPasswordVerify,
  SetNewPassword,
  Verify,
  Settings,
  IndependentIra,
  IndependentIraInfo,
  IndependentIraNew,
  ContributionsTable,
  ContributionDetails,
  ContributionDetailUser,
  Unsubscribe,
  IndependentIraTransactions,
  IndependentIraOpenOrders,
  IndependentIraAssets,
  IraUserTransactions,
  IraUserOpenOrders,
  IraUserAssets,
  ContributionDetailUserTransactions,
  ContributionDetailUserOpenOrders,
  ContributionDetailUserAssets,
  ReroutingToIraUserDetails,
  ReroutingToIraUserTransactions,
  ReroutingToIraUserOpenOrders,
  ReroutingToIraUserAssets,
} from 'screens';
import api from 'services/api';
import { useRole, Role } from 'hooks/common/useRole';
import { useAutoLogout } from 'hooks/api/login/useAutoLogout';
import {
  ROUTE_ETZ_PROFILE,
  ROUTE_ETZ_PROFILE_TRANSACTIONS,
  ROUTE_ETZ_PROFILE_ASSETS,
  ROUTE_ETZ_PROFILE_REVENUE,
  ROUTE_EMPLOYERS,
  ROUTE_LOGIN,
  ROUTE_LOGIN_BLOCKED,
  ROUTE_LOGIN_VERIFY,
  ROUTE_SETTINGS,
  ROUTE_IRA_USERS_ADMIN,
  ROUTE_NEW_IRAUSER_ADMIN,
  ROUTE_INFO_IRAUSER_ADMIN,
  ROUTE_FORGOT_PASSWORD,
  ROUTE_FORGOT_PASSWORD_VERIFY,
  ROUTE_SET_NEW_PASSWORD,
  ROUTE_IRA_ACCOUNTS,
  ROUTE_IRA_ACCOUNTS_NEW,
  ROUTE_IRA_ACCOUNTS_GENERAL_INFO,
  ROUTE_CONTRIBUTIONS,
  ROUTE_CONTRIBUTION_DETAILS,
  ROUTE_CONTRIBUTION_DETAIL_IRA_USER,
  ROUTE_CONTRIBUTION_DETAIL_IRA_ACCOUNT,
  ROUTE_INVITATION_UNSUBSCRIBE,
  ROUTE_IRA_ACCOUNTS_TRANSACTIONS,
  ROUTE_IRA_ACCOUNTS_OPEN_ORDERS,
  ROUTE_IRA_ACCOUNTS_ASSETS,
  ROUTE_INFO_IRAUSER_TRANSACTIONS,
  ROUTE_INFO_IRAUSER_OPEN_ORDERS,
  ROUTE_INFO_IRAUSER_ASSETS,
  ROUTE_CONTRIBUTION_DETAIL_IRA_USER_TRANSACTIONS,
  ROUTE_CONTRIBUTION_DETAIL_IRA_USER_OPEN_ORDERS,
  ROUTE_CONTRIBUTION_DETAIL_IRA_USER_ASSETS,
  ROUTE_CONTRIBUTION_DETAIL_IRA_ACCOUNT_TRANSACTIONS,
  ROUTE_CONTRIBUTION_DETAIL_IRA_ACCOUNT_OPEN_ORDERS,
  ROUTE_CONTRIBUTION_DETAIL_IRA_ACCOUNT_ASSETS,
  ROUTE_IRA_ACCOUNTS_IRA_USER_GENERAL_INFO,
  ROUTE_IRA_ACCOUNTS_IRA_USER_TRANSACTIONS,
  ROUTE_IRA_ACCOUNTS_IRA_USER_OPEN_ORDERS,
  ROUTE_IRA_ACCOUNTS_IRA_USER_ASSETS,
  ROUTE_ETZ_PROFILE_INFLOW_OUTFLOW,
} from 'constants/routes';
import Loader from 'components/Loader';

const App = () => {
  useAutoLogout();
  const { role } = useRole();

  // TODO: Refactor routing to remove rerouting components

  if (role === Role.Admin) {
    return (
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route
              path={ROUTE_ETZ_PROFILE}
              element={<Navigate to={ROUTE_ETZ_PROFILE_TRANSACTIONS} />}
            />
            <Route
              path={ROUTE_ETZ_PROFILE_TRANSACTIONS}
              element={<EtzProfileTransactions />}
            />
            <Route path={ROUTE_ETZ_PROFILE_ASSETS} element={<EtzProfileAssets />} />
            <Route
              path={ROUTE_ETZ_PROFILE_REVENUE}
              element={<EtzProfileRevenueTable />}
            />
            <Route
              path={ROUTE_ETZ_PROFILE_INFLOW_OUTFLOW}
              element={<EtzProfileInflowOutflowTable />}
            />
            <Route path={ROUTE_EMPLOYERS} element={<Employers />} />
            <Route path={ROUTE_IRA_ACCOUNTS} element={<IndependentIra />} />
            <Route
              path={ROUTE_IRA_ACCOUNTS_GENERAL_INFO}
              element={<IndependentIraInfo />}
            />
            <Route
              path={ROUTE_IRA_ACCOUNTS_TRANSACTIONS}
              element={<IndependentIraTransactions />}
            />
            <Route
              path={ROUTE_IRA_ACCOUNTS_OPEN_ORDERS}
              element={<IndependentIraOpenOrders />}
            />
            <Route path={ROUTE_IRA_ACCOUNTS_ASSETS} element={<IndependentIraAssets />} />
            <Route path={ROUTE_IRA_ACCOUNTS_NEW} element={<IndependentIraNew />} />

            <Route path={ROUTE_IRA_USERS_ADMIN} element={<IraUsers />} />
            <Route path={ROUTE_NEW_IRAUSER_ADMIN} element={<IraUserNew />} />
            <Route path={ROUTE_INFO_IRAUSER_ADMIN} element={<IraUserInfo />} />
            <Route
              path={ROUTE_INFO_IRAUSER_TRANSACTIONS}
              element={<IraUserTransactions />}
            />
            <Route
              path={ROUTE_INFO_IRAUSER_OPEN_ORDERS}
              element={<IraUserOpenOrders />}
            />
            <Route path={ROUTE_INFO_IRAUSER_ASSETS} element={<IraUserAssets />} />

            <Route
              path={ROUTE_IRA_ACCOUNTS_IRA_USER_GENERAL_INFO}
              element={<ReroutingToIraUserDetails />}
            />
            <Route
              path={ROUTE_IRA_ACCOUNTS_IRA_USER_TRANSACTIONS}
              element={<ReroutingToIraUserTransactions />}
            />
            <Route
              path={ROUTE_IRA_ACCOUNTS_IRA_USER_OPEN_ORDERS}
              element={<ReroutingToIraUserOpenOrders />}
            />
            <Route
              path={ROUTE_IRA_ACCOUNTS_IRA_USER_ASSETS}
              element={<ReroutingToIraUserAssets />}
            />

            <Route path={ROUTE_CONTRIBUTIONS} element={<ContributionsTable />} />
            <Route path={ROUTE_CONTRIBUTION_DETAILS} element={<ContributionDetails />} />
            <Route
              path={ROUTE_CONTRIBUTION_DETAIL_IRA_USER}
              element={<ContributionDetailUser />}
            />
            <Route
              path={ROUTE_CONTRIBUTION_DETAIL_IRA_USER_TRANSACTIONS}
              element={<ContributionDetailUserTransactions />}
            />
            <Route
              path={ROUTE_CONTRIBUTION_DETAIL_IRA_USER_OPEN_ORDERS}
              element={<ContributionDetailUserOpenOrders />}
            />
            <Route
              path={ROUTE_CONTRIBUTION_DETAIL_IRA_USER_ASSETS}
              element={<ContributionDetailUserAssets />}
            />
            <Route
              path={ROUTE_CONTRIBUTION_DETAIL_IRA_ACCOUNT}
              element={<ContributionDetailUser />}
            />
            <Route
              path={ROUTE_CONTRIBUTION_DETAIL_IRA_ACCOUNT_TRANSACTIONS}
              element={<ContributionDetailUserTransactions />}
            />
            <Route
              path={ROUTE_CONTRIBUTION_DETAIL_IRA_ACCOUNT_OPEN_ORDERS}
              element={<ContributionDetailUserOpenOrders />}
            />
            <Route
              path={ROUTE_CONTRIBUTION_DETAIL_IRA_ACCOUNT_ASSETS}
              element={<ContributionDetailUserAssets />}
            />

            <Route path={ROUTE_SETTINGS} element={<Settings />} />
          </Route>
          <Route path={'*'} element={<Navigate to={ROUTE_ETZ_PROFILE} />} />
        </Routes>
      </BrowserRouter>
    );
  }

  {
    /* // NOTE: Disabled in ETZ-2825. Need to check actuality. Related to 'Role User' */
  }
  // if (role === Role.User) {
  //   return (
  //     <BrowserRouter>
  //       <Routes>
  //         <Route element={<Layout />}>
  //           <Route path={ROUTE_DOCUMENTS} element={<Documents />} />
  //           <Route path={ROUTE_SETTINGS} element={<Settings />} />
  //           <Route path={ROUTE_IRA_USERS_USER} element={<IraUsers />} />
  //           <Route path={ROUTE_NEW_IRAUSER_USER} element={<IraUserNew />} />
  //           <Route path={ROUTE_INFO_IRAUSER_USER} element={<IraUserInfo />} />
  //         </Route>
  //         <Route path={'*'} element={<Navigate to={} />} />
  //       </Routes>
  //     </BrowserRouter>
  //   );
  // }

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<LoginLayout />}>
          <Route path={ROUTE_LOGIN} element={<Login />} />
          <Route path={ROUTE_LOGIN_VERIFY} element={<Verify />} />
          <Route path={ROUTE_LOGIN_BLOCKED} element={<LoginBlocked />} />
          <Route path={ROUTE_FORGOT_PASSWORD} element={<ForgotPassword />} />
          <Route path={ROUTE_FORGOT_PASSWORD_VERIFY} element={<ForgotPasswordVerify />} />
          <Route path={ROUTE_SET_NEW_PASSWORD} element={<SetNewPassword />} />
        </Route>
        <Route element={<InvitationLayout />}>
          <Route path={ROUTE_INVITATION_UNSUBSCRIBE} element={<Unsubscribe />} />
        </Route>
        {!api.accessToken ? (
          <Route path={'*'} element={<Navigate to={ROUTE_LOGIN} />} />
        ) : (
          <Route path={'*'} element={<Loader />} />
        )}
      </Routes>
    </BrowserRouter>
  );
};

export default App;
